import { ca } from '@cian/analytics';

export const trackOpenChatFastSearch = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FastSearch',
    action: 'Click',
    label: 'Chat_button/from=filters',
  });
};
